export default __webpack_public_path__ + "static/media/star.b6b0d419.png";